// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationTwoToneSvg from "@ant-design/icons-svg/es/asn/FileExclamationTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationTwoToneSvg
  }));
};

FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
export default React.forwardRef(FileExclamationTwoTone);